import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settled-payment',
  templateUrl: './settled-payment.component.html',
  styleUrls: ['./settled-payment.component.scss']
})
export class SettledPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
